import React, { useState } from 'react'
import { MainContainer } from '../Components/Elements'
import PagesNav from '../Components/PagesNav'
import { Offcanvas, Table } from 'react-bootstrap'
import SearchInput from '../Components/SearchInput'
import AddInput from '../Components/AddInput'
import MainInput from '../Components/MainInput'
import TableBtns from '../Components/TableBtns'
import AllUnitsHooks from '../hooks/Units/AllUnitsHooks'
import { Link } from 'react-router-dom'

const AllUnits = () => {
    const {
        NavItems,
        setSearch,
      } = AllUnitsHooks()
  
    return <>
    <MainContainer>
      <div className='d-flex gap-3 mb-3 align-items-center'>
      <PagesNav links={NavItems}/>
      <div className='d-flex gap-2'>
      <SearchInput  search={e => setSearch(e.target.value)}/>
        <Link to={"/units/addunit"}>
             <AddInput/>
        </Link>
      </div>
      </div>
  
      <Table hover className='text-center'>
        <thead>
          <tr>
            <th className='bg-light'>Unit Number</th>
            <th className='bg-light'>User Name</th>
            <th className='bg-light'>Type</th>
            <th className='bg-light'>Project</th>
            <th className='bg-light'>Unit Category</th>
            <th className='bg-light'>Unit Type</th>
            <th className='bg-light'>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Mark</td>
            <td>Otto</td>
            <td>Otto</td>
            <td>Otto</td>
            <td>Otto</td>
            <td>Otto</td>
            <td>
              <TableBtns/>
            </td>
          </tr>
        </tbody>
      </Table>
    
    </MainContainer>
  
  
  
    </>
}

export default AllUnits